import { PopoverOptions } from '@shared/types';

import { RootState } from '../../store';

export const getPopoverSelector = (state: RootState): PopoverOptions => state.popoverSliceReducer.popover;
